import React, { Component } from "react";
// 子组件
import StubIntactLine from "@/pages/displayBoard/stubIntactLine";
// 接口以及调用接口方法
import { intactRry } from "@/fetch/fetchApi";
import fetchHandler from "@/fetch/fetchHandler";
// 国际化切换语言
import { connect } from "react-redux";
import { injectIntl } from "react-intl";

@connect((state) => state)
class StubState extends Component {
  constructor(props) {
    super(props);
    this.props = props;
    this.state = {
      param: {
        cityIds: this.props.param.cityIds,
        provinceIds: this.props.param.provinceIds, // 默认 000000全国
        date: this.props.param.date,
        isMonth: this.props.param.isMonth,
        operationProperty: this.props.param.operationProperty,
        operationMode: this.props.param.operationMode,
      },
      queryDate: {
        averageErrorDuration: 0,
        averageOfflineDuration: 0,
        averageOperationDuration: 0,
        errorRate: 0,
        intactRate: 0,
        offlineRate: 0,
        totalStub: 0,
      },
    };
  }

  // 页面加载前获取完好率数据
  componentWillMount() {
    this.getIntactRate();
  }

  // 父组件修改param时执行
  componentWillReceiveProps(nextProps) {
    if (
      nextProps.param.provinceIds === this.state.param.provinceIds
      && nextProps.param.isMonth === this.state.param.isMonth
      && nextProps.param.cityIds === this.state.param.cityIds
      && nextProps.param.operationProperty === this.state.param.operationProperty
      && nextProps.param.stubType === this.state.param.stubType
      && nextProps.param.operationMode === this.state.param.operationMode
      && nextProps.param.date === this.state.param.date
    ) {
      // console.log("StubState 一样");
    } else {
      // console.log("StubState 不一样");
      this.setState(
        {
          param: {
            isMonth: nextProps.param.isMonth,
            cityIds: nextProps.param.cityIds,
            stubType: nextProps.param.stubType,
            provinceIds: nextProps.param.provinceIds, // 默认 000000全国
            date: nextProps.param.date,
            operationProperty: nextProps.param.operationProperty,
            operationMode: nextProps.param.operationMode,
          },
        },
        () => {
          // 获取数据
          this.getIntactRate();
        },
      );
    }
  }

  // 获取数据
  getIntactRate() {
    // 获取成功率数据1
    fetchHandler(intactRry, {
      startTime: this.state.param.date,
      cityIds: this.state.param.cityIds,
      isMonth:this.state.param.isMonth,
      stubType: this.state.param.stubType,
      operationMode: this.state.param.operationMode,
      operationProperty: this.state.param.operationProperty,
      provinceIds: this.state.param.provinceIds,
    }).then((res) => {
      // console.log(res);
      if (res.data) {
        this.setState({
          queryDate: {
            averageErrorDuration: res.data.averageErrorDuration,
            averageOfflineDuration: res.data.averageOfflineDuration,
            averageOperationDuration: res.data.averageOperationDuration,
            errorRate: res.data.errorRate,
            intactRate: res.data.intactRate,
            offlineRate: res.data.offlineRate,
            totalStub: res.data.totalStub,
          },
        });
        this.props.getStubIntactRate(res.data.intactRate);
      }
    });
  }

  // 秒转换
  handleSecord(value) {
    const day = Math.floor(value / (24 * 3600)); // Math.floor()向下取整
    const hour = Math.floor((value - day * 24 * 3600) / 3600);
    const minute = Math.floor((value - day * 24 * 3600 - hour * 3600) / 60);
    const second = value - day * 24 * 3600 - hour * 3600 - minute * 60;
    if (day > 0) {
      return `${day}天${hour}时${minute}分${second}秒`;
    } else if (hour > 0) {
      return `${hour}时${minute}分${second}秒`;
    } else if (minute > 0) {
      return `${minute}分${second}秒`;
    } else {
      return `${second}秒`;
    }
  }

  render() {
    const content = (
      <div className="board-inner">
        <div className="circle-part">
          <div className="circle-item">
            <div className="circle color1">
              {this.handleSecord(this.state.queryDate.averageOperationDuration)}
            </div>
            <div className="circle-title">平均完好时长</div>
          </div>
          <div className="circle-item">
            <div className="circle color2">
              {this.handleSecord(this.state.queryDate.averageOfflineDuration)}
            </div>
            <div className="circle-title">平均离线时长</div>
          </div>
          <div className="circle-item">
            <div className="circle color3">
              {this.handleSecord(this.state.queryDate.averageErrorDuration)}
            </div>
            <div className="circle-title">平均故障时长</div>
          </div>
        </div>
        <div className="line-title">当月设备状态趋势</div>
        <div className="line-part">
          <StubIntactLine param={this.state.param} />
        </div>
      </div>
    );

    return content;
  }
}

export default injectIntl(StubState);



// WEBPACK FOOTER //
// ./src/AntD/pages/displayBoard/stubState.js